import FavoritesClient from "./client/index.js";
export default FavoritesClient;
export var defaultInstance = new FavoritesClient();